import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class SuggestedWordService {
    private suggestedWord = new Subject<string>();

    public get SuggestedWordObservable(): Observable<string> {
        return this.suggestedWord.pipe();
    }

    public searchBySuggestedWord(word: string): void {
        this.suggestedWord.next(word);
    }
}
